export default __webpack_public_path__ + "static/media/close-red.08e39dd6.svg";